import { render, staticRenderFns } from "./AssetsIndexFieldtype.vue?vue&type=template&id=5a436a06&"
import script from "./AssetsIndexFieldtype.vue?vue&type=script&lang=js&"
export * from "./AssetsIndexFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports